import { Box, Heading, Text, createStandaloneToast } from '@chakra-ui/react';

import { ReactComponent as SuccessIcon } from '../assets/icons/success-tick.svg';
import { ReactComponent as ErrorIcon } from '../assets/icons/error-cross.svg';
import { NOTIFICATION_CLOSING_DURATION } from '../constants';
import { useTypedSelector } from '../hooks';

export const Notification = () => {
  const {
    title,
    description,
    isNotificationDisplayed,
    status = 'success',
  } = useTypedSelector(state => state.notification);
  const { toast } = createStandaloneToast();

  if (!isNotificationDisplayed) return;

  toast({
    duration: NOTIFICATION_CLOSING_DURATION,
    position: 'bottom-right',

    render: () => (
      <Box
        display="flex"
        gap="4"
        p="4"
        bg="white"
        borderRadius="lg"
        border="2px"
        borderColor="gray.200"
        maxWidth="400px"
      >
        <Box>{status == 'success' ? <SuccessIcon /> : <ErrorIcon />}</Box>
        <Box>
          <Heading mb="1" fontWeight="bold" fontSize="sm">
            {title}
          </Heading>
          <Text fontSize="sm">{description}</Text>
        </Box>
      </Box>
    ),
  });

  return null;
};
